import axios from 'axios'
import Vue from 'vue';
import {getSession} from "@/utils/methods"

let baseURL = process.env.VUE_APP_BI_API
let isRefreshing = false,
    requests = []
if(baseURL == '/biapi') {
    baseURL = window.biURL
}
Vue.prototype.$BIBaseUrl = baseURL
const server = axios.create({
    baseURL: baseURL,
    timeout: 50000,
    withCredentials: true
});

server.interceptors.request.use(
    config => {
        if (config.url !== '/auth') {
            config.headers.Authorization = getSession('BITOKEN') || '';
        }
        return config
    },
    err => {
        console.error('error://', err);
        return Promise.reject(err)
    }
)

server.interceptors.response.use(res=>{
        const { code } = res.data
        if(code == 401) {
            const config = res.config
            if(!isRefreshing){
                isRefreshing = true
                localStorage.removeItem('BITOKEN')
                requests = []
            }else{
                return new Promise(resolve=>{
                    requests.push(token=>{
                        resolve()
                    })
                })
            }
        }
        return res
    },
    err => { return Promise.reject(err) }
)

export default server
